import { Button, CTAPlannerCard, ItemsGrid } from 'dx-sdk/build/components';
import React, { useContext, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import HomeTile from '../../../components/HomeList/HomeTile/HomeTile';
import { DXAccountContext } from '../../../contexts/DXAccountContext';
import PlannerCTAIcon from '../../../images/portal/cta-planner-card-icon.PNG';
import plannerCardLinkIcon from '../../../images/portal/plannerCardLinkIcon.svg';
import plannerCTAAccent from '../../../images/portal/tealCTAAccent.svg';
import { fireSegmentEvent } from '../../../utils';
import { findFavoriteHomes, isPlannerComplete } from '../../utils/PortalUtils';
import FavoritesGridStyles from './FavoritesGrid.styled';

const FavoritesGrid = ({ dealer, homes }) => {
  const dxContext = useContext(DXAccountContext);
  const favoriteList = dxContext?.state.favorites;
  const favoriteHomes = findFavoriteHomes(favoriteList, homes);
  const [favoriteNumber, setFavoriteNumber] = useState(9);

  const location = useLocation();

  const homesList = useMemo(() => {
    return favoriteHomes?.slice(0, favoriteNumber).map((item) => {
      return {
        id: item.serialNumber || item.modelNumber,
        retailHomeObject: {
          ...item,
        },
      };
    });
  }, [favoriteHomes, favoriteNumber]);

  const questionsAreComplete = isPlannerComplete(
    dxContext?.state?.account?.plannerProgress
  );

  const handleHomeClick = (home) => {
    fireSegmentEvent('Facility Model Clicked', {
      baths: home?.baths,
      beds: home?.beds,
      modelName: home?.name || home?.modelName || '',
      basePrice: parseInt(home?.priceSort) || 0,
      length: 0,
      width: 0,
      modelSquareFeet: home?.squareFeet,
      modelNumber: home?.modelNumber || '',
      serialNumber: home?.serialNumber || '',
      eventContext: 'portal_favorites_home_card',
    });
  };

  return (
    <FavoritesGridStyles>
      <div className="grid-container">
        <ItemsGrid
          heading={
            homesList && homesList.length > 0 ? 'Your Favorite Homes' : null
          }
          componentsProps={{
            Grid: {
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            },
            Heading: {
              variant: 'h2',
              component: 'p',
            },
            SubHeading: {
              variant: 'caption',
              component: 'p',
            },
          }}
        >
          {homesList && homesList.length > 0 ? (
            <div className="favoritegrid-wrap">
              <div className="favoritegrid">
                {homesList?.map((item, i) => (
                  <HomeTile
                    key={item?.id || 'homelist-tile-' + i}
                    retailHomeObject={item.retailHomeObject}
                    dealer={dealer}
                    cardLinkState={{
                      dealer: dealer,
                      homes: homes,
                      homesOffset: null,
                      filter: null,
                      prevPath: location.pathname,
                    }}
                    handleClick={(e) => {
                      handleHomeClick(item.retailHomeObject);
                    }}
                  />
                ))}
              </div>
              {homesList.length >= favoriteNumber && (
                <div className="btn-wrap">
                  <Button
                    handlers={{
                      onClick: () => {
                        setFavoriteNumber(favoriteNumber + 9);
                      },
                    }}
                    className="load-more"
                  >
                    View More
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <CTAPlannerCard
              className="CTAPlannerCard-teal"
              accentImg={{ src: plannerCTAAccent, alt: 'CTA Icon' }}
              clickComponent={{ type: '', link: '' }}
              chip="Find Your Favorites"
              heading="Discover your favorite homes and features"
              backgroundColor="#007E86"
              icon={PlannerCTAIcon}
              components={{
                Click: () => (
                  <Link
                    to={{
                      pathname: questionsAreComplete
                        ? '/portal/homes-for-you'
                        : '/homes',
                      state: { dealer, homes },
                    }}
                    onClick={() => {
                      fireSegmentEvent('CTA Clicked', {
                        isNav: false,
                        type: 'card',
                        text: 'planner card link icon',
                        eventContext:
                          'portal_favorites_find_your_favorites_cta',
                      });
                    }}
                  >
                    <img
                      src={plannerCardLinkIcon}
                      alt="planner card link icon"
                    />
                  </Link>
                ),
              }}
            />
          )}
        </ItemsGrid>
      </div>
    </FavoritesGridStyles>
  );
};

export default FavoritesGrid;
